import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Header from './components/HeaderCarousel';
import MainSection from './components/MainSection';
import ProductCarousel from './components/ProductCarousel';
import ContactForm from './components/ContactForm';
import MissionSection from './components/MissionSection';
//import AutoScroll from './components/AutoScroll';
import Galeria from './components/Galeria';
import Video from './components/Video';
import './css/App.css';



function App() {
   const [views, setViews] = useState(0);
   const namespace = "chilerosdonrene";    
    const counterKey = "chilerosvisita"; // clave para tu contador global

   // 👁️ Incrementa el contador cuando la página se carga
  useEffect(() => {
     const updateViews = async () => {
      try {
        const alreadyCounted = sessionStorage.getItem("alreadyCounted");
        let url = `https://api.countapi.xyz/get/${namespace}/${counterKey}`;

        if (!alreadyCounted) {
          // Incrementa el contador global
          url = `https://api.countapi.xyz/hit/${namespace}/${counterKey}`;
          sessionStorage.setItem("alreadyCounted", "true");
        }

        const res = await fetch(url);
        const data = await res.json();
        setViews(data.value);
      } catch (error) {
        console.error("Error al obtener contador:", error);
      }
    };

    updateViews();
  }, []);


  return (
    <>
    
     <section className="inicio-section" id="inicio">
     </section>
       <Navbar />
      <Header />

       {/* <AutoScroll /> */}
      <MainSection />
      <ProductCarousel />
       <Galeria />
       <Video />
       <MissionSection />
      <ContactForm />

      {/* 👁️ CONTADOR DE VISITAS */}
      {/* <footer className="footer-views">
        👁️ {views} visitas
      </footer> */}
<a
  href="#inicio"
  className="scroll-top-float"
  aria-label="Volver al inicio"
>
  <img
    src={require('./img/home40.png')}
    alt="Inicio"
    className="home-icon"
  />
</a>
     <a
  href="https://wa.me/+50578176612?text=Hola,%20me%20puede%20dar%20informacion%20de%20sus%20productos,%20en%20especial%20de%20la%20Salsa:%20"
  className="whatsapp-float"
  target="_blank"
  rel="noopener noreferrer"
>
  <img
    src={require('./img/whatsapp70.png')}
    alt="WhatsApp"
    className="whatsapp-icon"
  />
</a>
    </>
  );
}

export default App;
